<template>
  <div
    v-if="header && headerHasContent"
    :class="['header-cont', globalClassAttributes]"
  >
    <div :style="styleAttributes">
      <HeaderContent
        :attributes="header?.attributes"
        :ctas="header?.ctas"
      >
        <template
          v-if="header?.attributes?.body"
          #[getLayout()]
        >
          <div
            class="body-text"
            v-html="sanitize(header?.attributes?.body, cleanStyles)"
          />
        </template>
      </HeaderContent>
    </div>
    <hr
      v-if="header?.attributes?.horizontalLine === 'true'"
      class="horizontal-line"
    >
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { sanitize } from '@vue-util/sanitize';
import {
  getClassAttributes,
  getStyleAttributes,
} from '../../helpers/getAttributes';
import cleanStyles from '../../helpers/getCleanStyles';
import HeaderContent from './HeaderContent';

const props = defineProps({
  header: {
    type: Object,
    default: () => {},
  },
});

const globalClassAttributes = getClassAttributes(props.header?.attributes);
const styleAttributes = getStyleAttributes(props.header?.attributes);
// default left layout if layout attribute equals left or is omitted
// determines which slot body text is passed to in order to render correect layout
const getLayout = () => (!props.header.attributes?.layout || props.header.attributes?.layout === 'left' ? 'heading' : 'body');

// Check if the header section has any content
const headerHasContent = computed(() => {
  const heading = props.header?.attributes?.heading ?? '';
  const body = props.header?.attributes?.body ?? '';
  const ctas = props.header?.ctas?.children?.length > 0 ?? null;
  return Boolean(body || heading || ctas);
});
</script>

<style lang="scss" scoped>
@import '~@core/foundation/scss/foundation-6.7.4/scss/prototype/_spacing.scss';

.horizontal-line {
  border-top: $gray-3-color solid 1px;
  margin-top: rem-calc(20);
}
</style>

<style lang="scss" brand="mcom" scoped>
@import './../../scss/globalAttributes.mcom.scss';

.header-cont {
  margin-bottom: rem-calc(32);
}

</style>

<style lang="scss" brand="bcom" scoped>
@import './../../scss/globalAttributes.bcom.scss';
@import "./../../scss/app.bcom.scss";

</style>
